import { Typography, Box, Button } from "@mui/material"
import tablet from '../../assets/svg/tablet.svg'
import mobile from '../../assets/svg/mobile.svg'
import { InfoOutlined } from "@mui/icons-material"

const UpdateInfo = ({ fieldType, onClose }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ flexGrow: 1 }}>
                <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, fontWeight: 600, mb: 1 }}>
                    Update Request in Progress
                </Typography>

                <Box textAlign="center" mb={5} mt={5}>
                    <img src={fieldType === 'email' ? tablet : mobile} alt="OTP" width={250} height={250} />
                </Box>

                <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, fontWeight: 500, mb: 1, color: '#F3D45E' }}>
                    Your {fieldType === 'email' ? 'Email' : 'Mobile'} change request is Initiated.
                </Typography>

            </Box>


            <Box>
                <Box display="flex" alignItems="center" mt={2} mb={2}>
                    <InfoOutlined fontSize="small" sx={{ color: "#888", mr: 1 }} />
                    <Typography sx={{ fontSize: '12px', color: "#888" }}>
                        We will inform you once your New {fieldType === 'email' ? 'Email' : 'Mobile'} is updated. This usually takes upto 48hours. Once the change is successfully completed, you would be logged out of all active sessions.
                    </Typography>
                </Box>

                <Button fullWidth onClick={onClose}>
                    Close
                </Button>
            </Box>
        </Box>
    )
}

export default UpdateInfo
